import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NovaRing = (props) => {
    const width = props.width ? props.width + 'px' : '158px';
    const height = props.height ? props.height + 'px' : '158px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 158 158"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M158 89.6804L158 158C70.8785 158 -3.0982e-06 87.1215 -6.9064e-06 0L68.3196 -2.98635e-06C68.3196 49.4535 108.556 89.6804 158 89.6804Z" />
        </SvgStyled>
    );
};

export default NovaRing;
